<template>
    <i class="fa fa-link" :style="{opacity: ad.url ? 1 : 0.2}" v-tooltip="ad.url"></i>
</template>

<script>
    export default {
        props: {
            ad: {
                type: Object,
                required: true
            }
        }
    }
</script>
